import { PosMappingDtoToEntity } from "src/app/features/PosMapping/services/mappers/PosMappingDtoToEntity";
import type { PosMappingDto } from "src/app/features/PosMapping/types/PosMappingDto";
import type { PosMappingEntity } from "src/app/features/PosMapping/types/PosMappingEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const PosMappingTableDtoMapper = (input: Readonly<ResourcePageDto<PosMappingDto>>): ResourcePageEntity<PosMappingEntity> => {
    return {
        list: input.list ? input.list.map(PosMappingDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
